import { render, staticRenderFns } from "./RoutesChart.vue?vue&type=template&id=15c95570&scoped=true&"
import script from "./RoutesChart.vue?vue&type=script&lang=js&"
export * from "./RoutesChart.vue?vue&type=script&lang=js&"
import style0 from "./RoutesChart.vue?vue&type=style&index=0&id=15c95570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c95570",
  null
  
)

export default component.exports